<script setup lang="ts">
import { VIcon } from 'vuetify/components';

withDefaults(
    defineProps<{
        size?: VIcon['$props']['size'];
        icon?: VIcon['$props']['icon'];
    }>(),
    { size: 'default' },
);

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VIcon
        v-bind="$attrs"
        :size="size"
        :icon="icon"
        class="b-icon"
    >
        <slot />
    </VIcon>
</template>
